import Cookies from 'js-cookie'

const clientId = Cookies.get("_ga")?.replace("GA1.1.", "").replace("GA.", "").replace("GA", "");

export default function useCookies() {
    return { clientId }
}